import { loadModules } from 'esri-loader';

function featureLayerApplyEdits(attrs){
    return loadModules(["esri/layers/FeatureLayer","esri/geometry/SpatialReference","esri/Graphic"]).then(([FeatureLayer,SpatialReference,Graphic]) => {
      const waterNetworkFeatureLayer = new FeatureLayer({
        url: process.env.__MAP_SERVER_URLS__.WATER_NETWORK_FS,
        layerId: 5
      });
  
      var j = {
        "attributes":attrs
      }
  
      return waterNetworkFeatureLayer.load().then(function(f){
        console.log(f)
          return f.applyEdits({
            updateFeatures:[j]
          })  
      }).otherwise(function (err) {
        console.log("there was an error: ", err);
        return err;
      });
    });
  
}

const state = {
    OBJECTID:null,
    UPD_DATE: null,
    UPD_BY: null,
    SYSTEM: null,
    SUB_SYSTEM: null,
    COMPONENT: null,
    SUB_COMPONENT: null,
    BUILDING: null,
    LEVEL_: null,
    ZONE_: null,
    POSTCODE: null,
    ASSET_ID: null,
    LDZ_ID: null,
    CONTRACT_REF: null,
    DIAMETER: null,
    PIPE_MATERIAL: null,
    INSTALL_YEAR: null,
    STATUS: null,
    ENABLE: null,
    TUNNEL: null,
    SLEEVE: null,
    BRANDNAME: null,
    LOCATION: null,
    DESCRIPTION: null,
    REMARK: null,
    ENABLED: null
}
// getters
const getters = {

}
const actions = {
    applyEdit({ state, commit }){
      //debugger;
      return featureLayerApplyEdits(state )
    },    
    updateAttributes({ state, commit }, newAttributeObj){
        //update resurfacing feature attributes
        commit('updateAttributes',newAttributeObj)
    },
    teardown({state,commit}){
        commit('teardown',
            {
                UPD_DATE: null,
                UPD_BY: null,
                SYSTEM: null,
                SUB_SYSTEM: null,
                COMPONENT: null,
                SUB_COMPONENT: null,
                BUILDING: null,
                LEVEL_: null,
                ZONE_: null,
                POSTCODE: null,
                ASSET_ID: null,
                LDZ_ID: null,
                CONTRACT_REF: null,
                DIAMETER: null,
                PIPE_MATERIAL: null,
                INSTALL_YEAR: null,
                STATUS: null,
                ENABLE: null,
                TUNNEL: null,
                SLEEVE: null,
                BRANDNAME: null,
                LOCATION: null,
                DESCRIPTION: null,
                REMARK: null,
                ENABLED: null
            }    
        )
    }
}
const mutations = {
    updateAttributes(state, newAttributeObj){
      Object.assign(state, newAttributeObj)  
    },
    teardown(state, newState){
      Object.assign(state, newState)
    }   
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/waterNetworkWaterPipe.js